import React, { useEffect } from "react";

export const Helmet = ({ children }) => {
  useEffect(() => {
    if (!children) return;
    const childArray = React.Children.toArray(children);
    childArray.forEach((child) => {
      if (!child || !child.type) return;
      if (child.type === "title" && child.props && child.props.children) {
        const titleText = Array.isArray(child.props.children)
          ? child.props.children.join("")
          : String(child.props.children);
        document.title = titleText;
      } else if (child.type === "meta" && child.props) {
        const { name, content } = child.props;
        if (name && content) {
          let meta = document.querySelector(`meta[name="${name}"]`);
          if (!meta) {
            meta = document.createElement("meta");
            meta.setAttribute("name", name);
            document.head.appendChild(meta);
          }
          meta.setAttribute("content", content);
        }
      }
    });
  }, [children]);

  return null;
};

export default Helmet;
